import { FormattedMessage } from 'react-intl';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import type { Props as PickerProps } from '../../PickerOnboardingDialog';
import { PickerOnboardingDialog } from '../../PickerOnboardingDialog';
import fiat from './assets/fiat.png';
import icons from './assets/icons.png';
import dailyMissionsMarqueeImgBottom from './assets/tape-daily-bw.png';
import dailyMissionsMarqueeImgTop from './assets/tape-daily-color.png';
import vaultMissionsMarqueeImgBottom from './assets/tape-vault-bw.png';
import vaultMissionsMarqueeImgTop from './assets/tape-vault-color.png';
import dialogBg from './assets/vault-mission-onboarding-bg.jpg';
import xp from './assets/xp.png';

type Props = {
  isVaultMission?: boolean;
  onClose: () => void;
};

const footballProps = {
  leftImg: xp,
  rightImg: xp,
  mobileImg: xp,
  iconsImg: icons,
  greenText: (
    <FormattedMessage
      id="missions.daily.picker.onboarding.description"
      defaultMessage="Win 200XP per successful pick!"
    />
  ),
  mainText: (
    <FormattedMessage
      id="missions.daily.picker.onboarding.title"
      defaultMessage="Pick 3 Players"
    />
  ),
  secondaryText: (
    <FormattedMessage
      id="missions.daily.picker.onboarding.canTheyHitADecisive"
      defaultMessage="Can They Hit a Decisive?"
    />
  ),
  captionText: (
    <FormattedMessage
      id="missions.daily.picker.onboarding.scarcityOfXpBasedOnCardScarcity"
      defaultMessage="Scarcity of XP based on Card scarcity"
    />
  ),
} as Omit<PickerProps, 'onClose'>;

const nbaProps = {
  leftImg: fiat,
  rightImg: fiat,
  mobileImg: fiat,
  greenText: (
    <FormattedMessage
      id="nba.missions.daily.picker.onboarding.description"
      defaultMessage="Win Cash!"
    />
  ),
  secondaryText: (
    <FormattedMessage
      id="nba.missions.daily.picker.onboarding.canTheyGetItDone"
      defaultMessage="Can They GET IT DONE?"
    />
  ),
} as Omit<PickerProps, 'onClose'>;

const dailyOrVaultProps = {
  daily: {
    mainText: (
      <FormattedMessage
        id="nba.missions.daily.picker.onboarding.title"
        defaultMessage="Pick 3 Players"
      />
    ),
    marqueeImgTop: dailyMissionsMarqueeImgTop,
    marqueeImgBottom: dailyMissionsMarqueeImgBottom,
  },
  vault: {
    dialogBg,
    mainText: (
      <FormattedMessage
        id="nba.missions.daily.picker.vault.onboarding.title"
        defaultMessage="Pick 3 sealed Players"
      />
    ),
    marqueeImgTop: vaultMissionsMarqueeImgTop,
    marqueeImgBottom: vaultMissionsMarqueeImgBottom,
  },
};

export const DecisivePlayerPickerOnboardingDialog = ({
  isVaultMission = false,
  onClose,
}: Props) => {
  const { sport } = useSportContext();
  const propsBySport = {
    [Sport.FOOTBALL]: footballProps,
    [Sport.NBA]: nbaProps,
    [Sport.BASEBALL]: nbaProps,
  };

  return (
    <PickerOnboardingDialog
      onClose={onClose}
      {...propsBySport[sport]}
      {...(isVaultMission ? dailyOrVaultProps.vault : dailyOrVaultProps.daily)}
    />
  );
};
